import classNames from "classnames";
import { useImagePath } from "hooks";
import useBreakpoints from "hooks/useBreakpoints";
import { LearnMoreItem } from "../../items";
import { CardStyled, Description, Img, Title } from "./styles";

interface CardProps {
	item: LearnMoreItem;
}

export const Card = ({ item }: CardProps) => {
	const { isSmDown } = useBreakpoints();
	const { image, description, title } = item;
	const { getImage } = useImagePath("cdn");

	return (
		<CardStyled
			className={classNames([isSmDown && "mobile", !isSmDown && "landscape"])}
		>
			<Img className="image" src={getImage(image)} />
			<div className="body">
				<Title className="title">{title}</Title>
				<Description className="description">{description}</Description>
			</div>
		</CardStyled>
	);
};
